module.exports = __webpack_public_path__ + "img/img_logo.03bcd89f.png";